<mat-dialog-content class="tw:h-full">
  <div class="tw:w-full tw:p-0 tw:m-0 content-container tw:h-full">

    <div class="tw:flex tw:flex-wrap tw:p-0 tw:m-0 tw:h-full">

      <div class="tw:flex-1 tw:m-0 tw:p-0 modal-type-container">
        <div class="tw:h-full tw:w-full success-strip"></div>
        <div class="icon-container">
          <i class="las la-check-circle la-5x white-icon"></i>
        </div>
      </div>

      <div class="tw:flex-1 modal-message-container">
        <p style="font-size: 24px;">Done!</p>
        @if (data.message) {
          <p class="font-16">{{ data.message }}</p>
        }
        <div class="modal-button-container">
          <button mat-button [mat-dialog-close]="false"
            class="btn tw:my-1 tw:mx-1 btn-primary" tabindex="-1">Dismiss</button>
        </div>
      </div>

    </div>

  </div>
</mat-dialog-content>
